/**
 * Ocakbaşı grupları — üye id’leri `members.js` içindeki `MEMBERS` ile eşleşmeli.
 *
 * @typedef {{
 *   id: string,
 *   name: string,
 *   memberIds: string[],
 * }} OcakbasiGroup
 */

/** @type {OcakbasiGroup[]} */
export const OCAKBASI_GROUPS = [
    {
        id: 'bogaz',
        name: 'Boğaz hattı',
        memberIds: [
            'm-0001',
            'm-0002',
            'm-0003',
            'm-0008',
            'm-0012',
            'm-0015',
        ],
    },
    {
        id: 'anadolu',
        name: 'Anadolu yakası',
        memberIds: [
            'm-0004',
            'm-0005',
            'm-0009',
            'm-0018',
            'm-0022',
            'm-0025',
            'm-0030',
        ],
    },
    {
        id: 'avrupa',
        name: 'Avrupa yakası',
        memberIds: [
            'm-0006',
            'm-0007',
            'm-0010',
            'm-0014',
            'm-0020',
        ],
    },
    {
        id: 'merkez',
        name: 'Merkez buluşma',
        memberIds: [
            'm-0011',
            'm-0013',
            'm-0016',
            'm-0019',
            'm-0024',
            'm-0028',
            'm-0032',
            'm-0035',
        ],
    },
    {
        id: 'hafta-ici',
        name: 'Hafta içi',
        memberIds: ['m-0021', 'm-0023', 'm-0026', 'm-0029'],
    },
    {
        id: 'hafta-sonu',
        name: 'Hafta sonu',
        memberIds: [
            'm-0027',
            'm-0031',
            'm-0033',
            'm-0034',
            'm-0036',
            'm-0040',
        ],
    },
];
